import { ref, nextTick, readonly } from 'vue'

const isLoading = ref(false)
const loadingMessage = ref('')

export function usePageLoading() {
  const startLoading = (message = '正在加载...') => {
    loadingMessage.value = message
    isLoading.value = true
  }

  const stopLoading = async () => {
    // 等待下一个tick确保所有组件都已渲染
    await nextTick()
    isLoading.value = false
  }

  const setLoadingMessage = (message: string) => {
    loadingMessage.value = message
  }

  return {
    isLoading: readonly(isLoading),
    loadingMessage: readonly(loadingMessage),
    startLoading,
    stopLoading,
    setLoadingMessage
  }
}

// 全局loading状态（用于路由切换）
export const globalLoading = {
  isLoading: readonly(isLoading),
  loadingMessage: readonly(loadingMessage),
  start: (message = '正在加载...') => {
    loadingMessage.value = message
    isLoading.value = true
  },
  stop: async () => {
    await nextTick()
    setTimeout(() => {
      isLoading.value = false
    }, 100) // 小延迟确保过渡自然
  },
  setMessage: (message: string) => {
    loadingMessage.value = message
  }
}
